import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const SaveButton = props => (
  <Button {...props}>
    {props.children}
    {props.saving === 'true' && (
      <CircularProgress size={24} style={{ position: 'absolute' }} />
    )}
  </Button>
);

SaveButton.propTypes = {
  saving: PropTypes.string.isRequired
};

export default SaveButton;
